import { Route, Routes } from "react-router-dom";
import ContactMessages from "./ContactMessages";
import AddCredits from "./creditManagement/AddCredits";
import CreditManagement from "./creditManagement/creditManagement";
import Dashboard from "./Dashboard";
import AddAdmin from "./franchiseAdmins/AddAdmin";
import CustomersTab from "./franchiseAdmins/CustomersTab";
import Franchises from "./franchiseAdmins/Franchises";
import Franchises2 from "./franchiseAdmins/Franchises2";
import FrymeTab from "./frymes/FrymeTab";
import MALayout from "./layout/MALayout";
import Settings from "./Settings";
import UserListTab from "./userManagement/userListTab";

const MADashboardRoute = () => {
  return (
    <Routes>
      <Route path="/" element={<MALayout />}>
        <Route index element={<Dashboard />} />
        <Route path="/user-management" element={<UserListTab />} />
        <Route path="/credit-management" element={<CreditManagement />} />
        <Route path="/credit-management/add-credits" element={<AddCredits />} />
        <Route path="/contact-messages" element={<ContactMessages />} />
        <Route path="/franchises" element={<Franchises />} />
        <Route path="/franchises/add" element={<AddAdmin />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/franchises/level2" element={<Franchises2 />} />
        <Route path="/franchises/customers" element={<CustomersTab />} />
          <Route path="/frymes-management" element={<FrymeTab />} />
      </Route>
    </Routes>
  );
};

export default MADashboardRoute;
